[
    {
        "status": "incomplete",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "ContinueQuote",
                "hooks": []
            },
            {
                "code": "Abandon",
                "hooks": []
            },
            {
                "code": "Submit",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "incomplete",
        "role": "broker",
        "type": "endorsement",
        "actions": [
            {
                "code": "GetQuote",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            }
        ]
    },
    {
        "status": "abandoned",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "Recover",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "submitted",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "AcceptSubmission",
                "hooks": []
            },
            {
                "code": "RejectSubmission",
                "hooks": [],
                "excludedProducts": []
            },
            {
                "code": "Lost",
                "hooks": [],
                "excludedProducts": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "submitted",
        "role": "broker",
        "type": "endorsement",
        "actions": [
            {
                "code": "GetQuote",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "accepted",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "GetQuote",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "referred",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "AcceptReferral",
                "hooks": []
            },
            {
                "code": "RejectReferral",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "quoted",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "ReQuote",
                "hooks": []
            },
            {
                "code": "IssueQuote",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "quoteIssued",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "RequestBind",
                "hooks": [],
                "excludedProducts": ["securemyoffer"]
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "quoteAccepted",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "RequestBind",
                "hooks": [],
                "excludedProducts": ["securemyoffer"]
            },
            {
                "code": "IssueQuote",
                "hooks": []
            },
            {
                "code": "RejectReferral",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "bindRequested",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "bound",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "Issue",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "issued",
        "role": "broker",
        "type": null,
        "actions": [
            {
                "code": "Endorse",
                "hooks": []
            }
        ]
    },
    {
        "status": "incomplete",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "ContinueQuote",
                "hooks": []
            },
            {
                "code": "Abandon",
                "hooks": []
            },
            {
                "code": "Submit",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "incomplete",
        "role": "administrator",
        "type": "endorsement",
        "actions": [
            {
                "code": "GetQuote",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            }
        ]
    },
    {
        "status": "abandoned",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "Recover",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "submitted",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "AcceptSubmission",
                "hooks": []
            },
            {
                "code": "RejectSubmission",
                "hooks": [],
                "excludedProducts": []
            },
            {
                "code": "Lost",
                "hooks": [],
                "excludedProducts": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "submitted",
        "role": "administrator",
        "type": "endorsement",
        "actions": [
            {
                "code": "GetQuote",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "accepted",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "GetQuote",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "referred",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "AcceptReferral",
                "hooks": []
            },
            {
                "code": "RejectReferral",
                "hooks": []
            },
            {
                "code": "RejectSubmission",
                "hooks": [],
                "applicableProducts": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "quoted",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "ReQuote",
                "hooks": []
            },
            {
                "code": "IssueQuote",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "quoteIssued",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "ConfirmBind",
                "hooks": [],
                "MGAProducts": ["securemyoffer"]
            },
            {
                "code": "RequestBind",
                "hooks": [],
                "excludedProducts": ["securemyoffer"]
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "quoteIssued",
        "role": "administrator",
        "type": "endorsement",
        "actions": [
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "quoteAccepted",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "RequestBind",
                "hooks": [],
                "excludedProducts": ["securemyoffer"]
            },
            {
                "code": "IssueQuote",
                "hooks": []
            },
            {
                "code": "RejectReferral",
                "hooks": []
            },
            {
                "code": "Lost",
                "hooks": []
            },
            {
                "code": "SendPaymentLink",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "bindRequested",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "bound",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "Issue",
                "hooks": []
            },
            {
                "code": "ChargeCard",
                "hooks": []
            }
        ]
    },
    {
        "status": "issued",
        "role": "administrator",
        "type": null,
        "actions": [
            {
                "code": "Endorse",
                "hooks": []
            }
        ]
    },
    {
        "status": "incomplete",
        "role": "broker",
        "type": "cancellation",
        "actions": [
            {
                "code": "CancellationQuote",
                "hooks": []
            },
            {
                "code": "ChangeCancellationDate",
                "hooks": []
            },
            {
                "code": "DeleteCancellation",
                "hooks": []
            }
        ]
    },
    {
        "status": "quoted",
        "role": "broker",
        "type": "cancellation",
        "actions": [
            {
                "code": "CancellationQuote",
                "hooks": []
            },
            {
                "code": "ChangeCancellationDate",
                "hooks": []
            },
            {
                "code": "DeleteCancellation",
                "hooks": []
            }
        ]
    },
    {
        "status": "incomplete",
        "role": "administrator",
        "type": "cancellation",
        "actions": [
            {
                "code": "CancellationQuote",
                "hooks": []
            },
            {
                "code": "ChangeCancellationDate",
                "hooks": []
            },
            {
                "code": "DeleteCancellation",
                "hooks": []
            }
        ]
    },
    {
        "status": "quoted",
        "role": "administrator",
        "type": "cancellation",
        "actions": [
            {
                "code": "CancellationQuote",
                "hooks": []
            },
            {
                "code": "Refund",
                "hooks": []
            },
            {
                "code": "ChangeCancellationDate",
                "hooks": []
            },
            {
                "code": "DeleteCancellation",
                "hooks": []
            }
        ]
    }
]
